<template>
  <div>
    <bank-account-filter
      :bankList="bankList"
      :clientList="clientList"
      v-model="params"
      @search="handleSearch"
    />
    <bank-account-sidebar
      :bankList="bankList"
      :clientList="clientList"
      :bankAccount="account"
      @search="handleSearch"
    />
    <vs-card>
      <div id="bank-account-table-loading" class="vs-con-loading__container">
        <vs-row>
          <vs-col vs-xs="12" vs-sm="12" vs-lg="12">
            <bank-account-table
              :data="list"
              @add="add"
              @edit="edit"
              @filter="filter"
              @loadMore="loadMore"
              @search="handleSearch"
              @sort="sort"
            />
          </vs-col>
        </vs-row>
      </div>
    </vs-card>
  </div>
</template>

<script>
import BankAccountTable from './components/BankAccountTable'
import BankAccountFilter from './components/BankAccountFilter'
import BankAccountSidebar from './components/BankAccountSidebar'
import AddButton from '@/views/components/buttons/AddButton'
import loading from '@/mixins/Loading'
import moduleBankAccount from '@/store/bankAccount/moduleBankAccount.js'
import statement from '@/http/requests/statement'
import client from '@/http/requests/client'

export default {
  components: {
    BankAccountTable,
    BankAccountFilter,
    AddButton,
    BankAccountSidebar,
  },
  computed: {
    list() {
      return this.$store.state.bankAccount.bankAccountList
    },
    isLoading() {
      return (
        this.loading.bankAccountList ||
        this.loading.clientList ||
        this.loading.bankList
      )
    },
  },
  created() {
    if (!moduleBankAccount.isRegistered) {
      this.$store.registerModule('bankAccount', moduleBankAccount)
      moduleBankAccount.isRegistered = true
    }
  },
  data: () => ({
    lastPage: '',
    params: {
      client_id: [],
      bank_id: [],
      currency: [],
      cash_request: false,
    },
    loading: {
      bankAccountList: false,
      clientList: false,
      bankList: false,
    },
    bankList: [],
    clientList: [],
    search: '',
    page: 1,
    account: {},
  }),
  methods: {
    getData() {
      this.loading.bankAccountList = true
      let data = Object.assign({}, this.params)
      data.page = this.page
      data.search = this.search
      this.$store
        .dispatch('bankAccount/fetchBankAccountList', data)
        .then((res) => {
          this.lastPage = res.data.last_page
          this.loading.bankAccountList = false
        })
        .catch((err) => {
          this.loading.bankAccountList = false
        })
    },
    init() {
      this.getData()
      this.getClientList()
      this.getBankList()
    },
    loadMore() {
      if (this.page >= this.lastPage) {
        return
      }
      this.page++
      this.getData()
    },
    handleSearch(text) {
      this.search = text
      this.page = 1
      this.getData()
    },
    sort(e) {
      this.params.sortBy = e.sortBy
      this.params.sort = e.sort
      this.getData()
    },
    getClientList() {
      this.loading.clientList = true
      client
        .list()
        .then((res) => {
          this.clientList = res.data.clients
          this.loading.clientList = false
        })
        .catch((err) => {
          this.loading.clientList = false
        })
    },
    getBankList() {
      this.loading.bankList = true
      statement
        .bankList()
        .then((res) => {
          this.bankList = res.data.banks
          this.loading.bankList = false
        })
        .catch((err) => {
          this.loading.bankList = false
        })
    },
    filter() {
      this.$store.dispatch('toggleSidebar', 'bank-account-filter')
    },
    add() {
      this.account = Object.assign({}, null)
      this.$store.dispatch('toggleSidebar', 'bank-account')
    },
    edit(account) {
      this.account = Object.assign({}, account)
      console.log(this.account)
      this.$store.dispatch('toggleSidebar', 'bank-account')
    },
  },
  mixins: [loading],
  mounted() {
    this.init()
  },
  watch: {
    isLoading(val) {
      if (val) {
        this.openLoading(`bank-account-table-loading`)
      } else {
        this.closeLoading(`bank-account-table-loading`)
      }
    },
  },
}
</script>

<style>
</style>